<template>
  <div>
    <tablegeneric
      :headers="headers"
      :formfields="formfields"
      url="/admin/acessotelas"
      incluir="acesso_tela_incluir"
      editar="acesso_tela_editar"
      excluir="acesso_tela_excluir"
      exportar="acesso_tela_exportar p/excel"
      imprimir="acesso_tela_imprimir"
      clonar="acesso_tela_clonar"
    />
  </div>
</template>

<script>
import headers from './headers.mixins'
import formfields from './formfields.mixins'

export default {
  name: 'Home',
  components: {
    tablegeneric: () => import('@/components/tablegeneric')
  },
  mixins: [
    headers,
    formfields
  ]
}
</script>

<style>
</style>
